﻿window.BW = {
    disabledDates: '',
    flatpickr: {
        instance: '',
        checkIn: null,
        checkOut: null,
    },
}

document.addEventListener('DOMContentLoaded', function () {
    var locationInput = document.getElementById('searchLocation');
 
    if (locationInput) {
        locationInput.addEventListener('keyup', find);
    }
});

function initFlatpickr() {
    window.BW.disabledDates = window.disabledDates ? window.disabledDates : '';

    window.BW.flatpickr.instance = window.flatpickr(".flatpickr", {
        altInput: true,
        altFormat: "m/d/Y",
        mode: "range",
        minDate: "today",
        dateFormat: "m/d/Y",
        monthSelectorType: "static",
        yearSelectorType: "static",
        disable: [shouldDisableDate],
        onReady: function (dates, stringDates, instance) {
            const checkIn = instance.input.dataset.start;
            const checkOut = instance.input.dataset.end;

            instance.setDate([checkIn ? new Date(checkIn) : null, checkOut ? new Date(checkOut) : null]);
        },
    });

    function pickDate(date) {
        setTimeout(function () {
            window.BW.flatpickr.instance.setDate(date);
            window.BW.flatpickr.instance.open();
        }, 0);
    }
    
    function shouldDisableDate(date) {
        var dateUTC = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()));
        return window.BW.disabledDates.includes(dateUTC.toISOString().substring(0, 10));
    }
}

/* Modals */

function openModal(id, top, left) {
    window.BW_currentModal = $('#' + id);
    window.BW_currentModal.css({top: top, left: left});
    $('#modalOverlay').show();
    window.BW_currentModal.show();
}

function closeModal() {
    $('#modalOverlay').hide();
    window.BW_currentModal.hide();
}

/* Filters */

function clearSearchFilters() {
    ['cin', 'cout', 'a', 'g'].forEach(name => {
        document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
    });

    window.location.reload();
}

/* Menu */

function toggleMenu() {
    $('#navMenu').toggle();
}

/* Home Search */
var hsSelectedObj;
var hsSelectedLocationID;
var hsSelectedGuestNumber;
var hsSelectedCheckInDate;
var hsSelectedCheckOutDate;

function hsSelectObj(name) {
    hsSelectedObj.val(name);
    hsSelectedObj.removeClass('on');
    hsSelectedObj.addClass('selected');
    closeModal();
}

function hsOpenLocationModal() {
    hsSelectedObj = $('#searchLocation');
    hsSelectedObj.addClass('on');
    openModal('modalLocation', hsSelectedObj.offset().top + 35, hsSelectedObj.offset().left - 18);
    return false;
}

function hsSelectLocation(name, id) {
    hsSelectedLocationID = id;
    hsSelectObj(name);
}

function hsOpenGuestsModal() {
    hsSelectedObj = $('#searchGuests');
    hsSelectedObj.addClass('on');
    openModal('modalGuests', (hsSelectedObj.offset().top - $(window).scrollTop()) + 35, hsSelectedObj.offset().left - 12);
    return false;
}

function hsSelectGuests(name, id) {
    if (id === 0) {
        hsSelectedGuestNumber = $('#textGuests').val();
        hsSelectObj($('#textGuests').val());
    } else {
        hsSelectedGuestNumber = id;
        hsSelectObj(name);
    }
}

function hsOpenAmenitiesModal() {
    hsSelectedObj = $('#searchAmenities');
    hsSelectedObj.addClass('on');
    openModal('modalAmenities', (hsSelectedObj.offset().top - $(window).scrollTop()) + 35, hsSelectedObj.offset().left - 12);
    return false;
}

function hsOpenCalendarModal(mode) {
    openModal('modalCalendar', hsSelectedObj.offset().top + 35, hsSelectedObj.offset().left - 28);
}

function handleSearch(date) {
    var location = $('#searchLocation').attr('data-id');
    var guests = $('#searchGuests').val();
    var checkInDate = !!window.BW.flatpickr.instance.selectedDates[0] ? flatpickr.formatDate(window.BW.flatpickr.instance.selectedDates[0], 'm/d/Y') : null;
    var checkOutDate = !!window.BW.flatpickr.instance.selectedDates[1] ? flatpickr.formatDate(window.BW.flatpickr.instance.selectedDates[1], 'm/d/Y') : null;

    var params = new URLSearchParams();

    if (location) {
        params.append('l', location);
    }
    if (guests) {
        params.append('g', guests);
    }
    if (checkInDate) {
        params.append('i', checkInDate);
    }
    if (checkOutDate) {
        params.append('o', checkOutDate);
    }

    document.location = "/search/?" + params;
}

function dateSplitter(elementID) {
    var dateRange = $("#" + elementID);
    return dateRange.val().split(" to ");
}

function getCurrency(numeric) {
    return numeric.toLocaleString("en-us", {
        style: 'currency',
        currency: 'USD'
    });
}

function find() {
    var text = $("#searchLocation").val();

    if (text.length === 0 || text.length > 3) {
        var url = '/api/find/?text=' + text;
        $.getJSON(url).done(function (data) {
            renderResults(data);
        }).fail(function () {
        }).always(function () {
        });
    }
}

function renderResults(data) {
    var html = "";

    if (data.results != null) {
        for (var i = 0; i < data.results.length; i++) {
            var item = data.results[i];
            if (item.type === "destination")
                html += getDestinationRowHtml(item);
            else
                html += getRentalRowHtml(item);
        }
    }

    var searchAuto = $("#searchAuto");

    if (html !== "")
        searchAuto.html("<table>" + html + "</table>");

    var searchArea = $("#searchLocation");
    var x = (searchArea.offset().top - $(window).scrollTop()) + 30;
    var y = searchArea.offset().left - 12; // + searchArea.width();
    searchAuto.css({top: x, left: y});
    searchAuto.show();
}

function getDestinationRowHtml(item) {
    return "<tr><td><a href=\"javascript: selectDestination(" + item.id + ", '" + item.name + "');\">" + item.name + "</a></td><td>&nbsp;</td></tr>";
}

function getRentalRowHtml(item) {
    return "<tr><td><a href=\"" + item.url + "\">" + item.name + "</a></td><td>RENTAL</td></tr>";
}

function selectDestination(id, name) {
    $("#searchLocation").val(name).attr('data-id', id);
    $("#searchAuto").hide();
}

function selectRental(url) {
    document.URL = url;
}

/* Helpers */

function getCookie(name) {
    let match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
    return match ? match[2] : null;
}

/* jQuery Load */

function handleJQueryLoad() {
    (function ($) {
        $.extend({

            debounce: function (fn, timeout, invokeAsap, ctx) {
                if (arguments.length == 3 && typeof invokeAsap != 'boolean') {
                    ctx = invokeAsap;
                    invokeAsap = false;
                }

                var timer;

                return function () {

                    var args = arguments;
                    ctx = ctx || this;

                    invokeAsap && !timer && fn.apply(ctx, args);

                    clearTimeout(timer);

                    timer = setTimeout(function () {
                        !invokeAsap && fn.apply(ctx, args);
                        timer = null;
                    }, timeout);

                };

            },

            throttle: function (fn, timeout, ctx) {

                var timer, args, needInvoke;

                return function () {

                    args = arguments;
                    needInvoke = true;
                    ctx = ctx || this;

                    if (!timer) {
                        (function () {
                            if (needInvoke) {
                                fn.apply(ctx, args);
                                needInvoke = false;
                                timer = setTimeout(arguments.callee, timeout);
                            } else {
                                timer = null;
                            }
                        })();
                    }

                };

            }

        });

    })(jQuery);
}
